import { inject, Injectable } from '@angular/core';
import { InventoryConfig } from '../types/inventory-config';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  ModuleConfig,
  RemoteConfigProperty,
  RemoteConfigStore,
  SOFTLINE_FEATURE_REMOTE_CONFIG,
} from '@softline/application';
import { filter, map } from 'rxjs';
import { Store } from '@softline/core';

function getPropValue(key: string, properties: RemoteConfigProperty[]): string {
  return properties.find((o) => o.key === key)?.value ?? '';
}

@Injectable()
export class InventoryConfigService {
  private readonly store = inject(Store);

  readonly value = toSignal(
    this.store
      .observe(SOFTLINE_FEATURE_REMOTE_CONFIG, RemoteConfigStore.getters.data)
      .pipe(
        filter((o) => !!o && !!o?.modules),
        map((data) => data?.modules?.find((o) => o.module === 'mde-inventur')),
        map((moduleConfig) => this.toInventoryConfig(moduleConfig))
      )
  );

  private toInventoryConfig(
    moduleConfig: ModuleConfig | undefined
  ): InventoryConfig | null {
    if (!moduleConfig) return null;

    const lagerEingabe =
      getPropValue('FELD_LAGER', moduleConfig.properties) === 'editierbar';
    const lagerplatzEingabe =
      getPropValue('FELD_LAGERPLATZ', moduleConfig.properties) === 'editierbar';
    const belegdatumEingabe =
      getPropValue('FELD_BELEGDATUM', moduleConfig.properties) !== 'ausgeblendet';
    const belegdatumEditierbar =
      getPropValue('FELD_BELEGDATUM', moduleConfig.properties) === 'editierbar';
    const addierenErlaubt =
      getPropValue('FELD_ADDIEREN', moduleConfig.properties) === 'editierbar';
    const addierenSichtbar =
      getPropValue('FELD_ADDIEREN', moduleConfig.properties) !== 'ausgeblendet';
    const hinweisAbweichendeMenge =
      getPropValue('HINWEIS_ABWEICHENDE_MENGE', moduleConfig.properties) === 'true';
    const showSchwundlisteDialog =
      getPropValue('FELD_SCHWUNDLISTE', moduleConfig.properties) === 'eingeblendet';
    const showLagerstand =
      getPropValue('FELD_LAGERSTAND', moduleConfig.properties) === 'lagerstand';

    return {
      addierenErlaubt,
      addierenSichtbar,
      hinweisAbweichendeMenge,
      showSchwundlisteDialog,
      belegdatumEingabe,
      lagerplatzEingabe,
      lagerEingabe,
      belegdatumEditierbar,
      showLagerstand,
    };
  }
}
